export default __webpack_public_path__ + "static/media/webtable3.6a17c8b5.png";